import clsx from 'clsx'
import classes from './button.module.css'

export type ButtonType = "primary" | "secondary" | undefined;
interface ButtonProps {
  variant?: ButtonType
  text: string
  onClick?: () => void
  style?: React.CSSProperties
}
export default function Button({variant = 'primary', text, onClick, style}: ButtonProps) {
  return (
    <button onClick={onClick} style={style} className={clsx(classes.btn, classes[variant])}>
      {text}
    </button>
  )
}
